// TODO 0622 오픈 버전에서 버튼 주석 처리, 추 후 오픈 예정

import { useState } from 'react'
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import { useSignOut } from '~/features/auth/queries/useAuth'
import { removeAuthInfo } from '~/features/auth/utils/auth'
import ChevronDown from '~/shared/assets/icons/ChevronDown'
import ChevronUp from '~/shared/assets/icons/ChevronUp'
import Close from '~/shared/assets/icons/Close'
import Menu from '~/shared/assets/icons/Menu'
// import Search from '~/shared/assets/icons/Search'
import defaultProfileImage from '~/shared/assets/images/default-profile.png'
import Button from '~/shared/components/buttons/Button'
import { isModalOpenState } from '~/shared/states'
import theme from '~/shared/styles/theme'
import { displayMenuItems } from '~/shared/utils/routes'

function MobileHeader() {
  const HeaderLogo = `${import.meta.env.VITE_STATIC_ENDPOINT}/assets/logos/illustar-favicon.svg`
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()

  const { mutate: signOutMutate } = useSignOut()

  const accessToken = localStorage.getItem('starlike-access-token')
  const refreshToken = localStorage.getItem('starlike-refresh-token')
  const userName = localStorage.getItem('starlike-user-name')

  const signOut = () => {
    removeAuthInfo()
    signOutMutate(
      {
        refreshToken: refreshToken as string,
      },
      {
        onSuccess: (res) => {
          if (!res.errorCode) {
            enqueueSnackbar('로그아웃 되었습니다.', { variant: 'success' })
            navigate('/')
          }
        },
      },
    )
  }

  const [_, setIsModalOpen] = useRecoilState(isModalOpenState)
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)
  const [openedSubmenu, setOpenedSubmenu] = useState('')

  return (
    <>
      {isMenuOpen ? (
        <MenuContainer>
          <ContainerTop>
            <Logo
              src={HeaderLogo}
              alt="logo"
              onClick={() => {
                navigate('/')
                setIsMenuOpen(false)
              }}
            />
            <CloseIcon
              onClick={() => {
                setIsMenuOpen(false)
                setOpenedSubmenu('')
              }}
            />
          </ContainerTop>
          {accessToken && (
            <UserInfoBox>
              <div
                className="user-info"
                onClick={() => {
                  setIsMenuOpen(false)
                  navigate('/mypage')
                }}
              >
                <img
                  className="user-profile"
                  src={defaultProfileImage}
                  alt="profile"
                />
                <div className="user-name">{userName}님</div>
              </div>
              <Button
                onClick={signOut}
                $width={94}
                $height={21}
                $fontSize={15}
                $variant="black"
              >
                로그아웃
              </Button>
            </UserInfoBox>
          )}

          {displayMenuItems.map((menu) => {
            const hasSingleSubItem = menu.subItems && menu.subItems.length === 1

            return (
              <div key={menu.id}>
                <MenuItemBox>
                  <MenuItem
                    onClick={() => {
                      if (hasSingleSubItem) {
                        navigate(menu.subItems![0].path)
                        setIsMenuOpen(false)
                      } else if (openedSubmenu === menu.title) {
                        setOpenedSubmenu('')
                      } else {
                        setOpenedSubmenu(menu.title)
                      }
                    }}
                    key={menu.path}
                  >
                    <MenuTitle $bold={openedSubmenu === menu.title}>
                      {menu.title}
                      {menu.path === '/sif-rainbowstage1' && (
                        <SpecialText>SIF Rainbow Stage</SpecialText>
                      )}
                    </MenuTitle>

                    {menu.subItems &&
                    menu.subItems.length > 1 &&
                    openedSubmenu === menu.title ? (
                      <ChevronUp />
                    ) : (
                      !hasSingleSubItem && <ChevronDown />
                    )}
                  </MenuItem>
                  {menu.subItems &&
                    menu.subItems.length > 1 &&
                    openedSubmenu === menu.title &&
                    menu.subItems.map((subItem) => {
                      return (
                        <MenuSubItem
                          key={subItem.path}
                          onClick={() => {
                            navigate(subItem.path)
                            setIsMenuOpen(false)
                          }}
                        >
                          {subItem.name}
                        </MenuSubItem>
                      )
                    })}
                </MenuItemBox>
              </div>
            )
          })}

          {!accessToken && (
            <ButtonBox>
              <Button
                $width={92}
                $height={47}
                $fontSize={18}
                $variant="transparent"
                onClick={() => {
                  setIsModalOpen({ contents: 'sign-in', isOpen: true })
                  setIsMenuOpen(false)
                }}
              >
                로그인
              </Button>
              <Button
                $width={92}
                $height={47}
                $fontSize={18}
                $variant="black"
                onClick={() => {
                  setIsModalOpen({ contents: 'sign-up', isOpen: true })
                  setIsMenuOpen(false)
                }}
              >
                회원가입
              </Button>
            </ButtonBox>
          )}
        </MenuContainer>
      ) : (
        <Wrapper>
          <Logo
            src={HeaderLogo}
            alt="logo"
            onClick={() => {
              navigate('/')
            }}
          />
          <IconBox>
            {/* <Search onClick={() => navigate('/circle-participation/info')} /> */}
            <Menu onClick={() => setIsMenuOpen(true)} />
          </IconBox>
        </Wrapper>
      )}
    </>
  )
}

export default MobileHeader

const Wrapper = styled.header`
  position: absolute;
  z-index: ${theme.zIndex.header};
  top: 0;
  right: 0;
  left: 0;

  display: flex;
  flex-direction: row;
  gap: 120px;
  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;
  width: 100vw;
  height: ${theme.size.mobileHeaderHeight}px;
  padding: 20px 16px;

  background-color: transparent;
`

const Logo = styled.img`
  cursor: pointer;
  width: 40px;
  height: auto;
`

const IconBox = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
`

const MenuContainer = styled.div`
  position: absolute;
  z-index: ${theme.zIndex.header};

  width: 100%;
  height: 100%;

  background-color: white;
`

const ContainerTop = styled.div`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 20px 16px;
`

const CloseIcon = styled(Close)`
  width: 32px;
  height: 32px;
`

const MenuItemBox = styled.div`
  width: 90%;
  margin: 0 auto;
  border-bottom: 1px solid #c1c3c2;
`

const UserInfoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 90%;
  margin: 10px auto;

  .user-profile {
    width: 46px;
    height: 46px;
    background-color: #c4c4c4;
    border-radius: 50%;
  }

  .user-info {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
  }
`

const MenuItem = styled.div`
  cursor: pointer;

  display: flex;
  justify-content: space-between;

  box-sizing: border-box;
  padding: 20px 0;

  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 18px;
`

const MenuTitle = styled.span<{ $bold: boolean }>`
  ${({ $bold }) =>
    $bold
      ? 'font-family: NanumSquareNeo-Bold, sans-serif;'
      : 'font-family: NanumSquareNeo-Regular, sans-serif;'}
  font-size: 18px;
`

const SpecialText = styled.span`
  margin-left: 10px;
  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 14px;
`

const MenuSubItem = styled.div`
  margin: 0 auto 20px 20px;

  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 21px;
`

const ButtonBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  box-sizing: border-box;
  width: 100%;
  padding: 20px 16px;
`
